import * as config from '../../assets/config.json';

const message: any = {}
for (const key in config) {
    // if (config.hasOwnProperty(key)) {
        message[key] = (config as any)[key];
    // }
}
export const configMessage: any = message.default;
